const stepsForAsset = [
    { label: "Basic Details", key: "Basic Details", value: "0", labelId: 0 },
    { label: "Assessments", key: "Assessments", value: "16", labelId: 1 },
    { label: "Attachments", key: "Attachments", value: "88", labelId: 2 },
    { label: "Part Replacement", key: "Part Replacement", value: "32", labelId: 3 },
    { label: "Completion Info", key: "Completion Info", value: "48", labelId: 4 },
    { label: "Cost Info", key: "Cost Info", value: "68", labelId: 5 },
    { label: "Authorization & Summary", key: "Authorization & Summary", value: "92", labelId: 6 },
];

const checkPartsRequiredReducer = (state = stepsForAsset, action) => {


    switch (action.type) {
        case "UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED":

            return action.payload;

        case "UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE":

            return stepsForAsset;
        // case "UPDATE_STEP_ID":
        //     return state.map((step, index) =>
        //         index === action.payload.index ? { ...step, id: action.payload.id } : step
        //     );


        default:
            return state;
    }
};

export default checkPartsRequiredReducer;